import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=68c36bcb&lang=pug"
import script from "./Providers.vue?vue&type=script&lang=js"
export * from "./Providers.vue?vue&type=script&lang=js"
import style0 from "./Providers.vue?vue&type=style&index=0&id=68c36bcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,FormProviders: require('/home/docker/code/frontend/components/form/Providers.vue').default})
